import React, { useState, useEffect } from 'react';

const RANKS = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
const SUITS = ['s', 'h', 'd', 'c'];

const suitToName = {
  's': '黑桃',
  'h': '红桃',
  'd': '方块',
  'c': '梅花'
};

// 修改 CardSelector 组件
const CardSelector = ({ onSelectCards, numCards, usedCards = [] }) => {
  const [selectedCards, setSelectedCards] = useState([]);

  useEffect(() => {
    if (selectedCards.length === numCards) {
      onSelectCards(selectedCards);
    }
  }, [selectedCards, numCards, onSelectCards]);

  const handleCardClick = (card) => {
    if (selectedCards.includes(card)) {
      setSelectedCards(selectedCards.filter(c => c !== card));
    } else if (selectedCards.length < numCards) {
      setSelectedCards([...selectedCards, card]);
    }
  };

  const cards = RANKS.flatMap(rank => 
    SUITS.map(suit => `${rank}${suit}`)
  );

  return (
    <div className="bg-green-100 rounded p-2 w-full">
      <div className="grid grid-rows-4 grid-flow-col gap-0.5">
        {cards.map(card => {
          // 如果卡片已经被使用且不在当前选择中，则禁用
          const isDisabled = usedCards.includes(card) && !selectedCards.includes(card);
          
          return (
            <button
              key={card}
              onClick={() => !isDisabled && handleCardClick(card)}
              className={`aspect-[2/3] w-full rounded-md ${
                selectedCards.includes(card) ? 'ring-2 ring-blue-500' : ''
              } ${isDisabled ? 'opacity-30 cursor-not-allowed' : ''} 
              border border-gray-400 shadow hover:shadow-lg transition-all duration-200 overflow-hidden
              hover:border-gray-500`}
              style={{
                backgroundImage: `url(/images/cards/${card}.svg)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
              disabled={isDisabled}
            />
          );
        })}
      </div>
      <div className="mt-4 flex justify-center">
        {selectedCards.map((card, index) => (
          <div
            key={index}
            className="w-12 h-16 mx-1 rounded-md shadow border border-gray-400 hover:shadow-lg 
            transition-all duration-200 overflow-hidden hover:border-gray-500"
            style={{
              backgroundImage: `url(/images/cards/${card}.svg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        ))}
        {Array.from({ length: numCards - selectedCards.length }, (_, index) => (
          <div
            key={`placeholder-${index}`}
            className="w-12 h-16 mx-1 rounded-md border-2 border-gray-300 flex items-center justify-center bg-white"
          >
            <span className="text-gray-400 text-xs">?</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardSelector;